export default class InternationalBankModel {
  constructor(obj) {
    obj = obj || {};

    this.bank = obj.bank;
    this.swiftCodeBIC = obj.swiftCodeBIC;
    this.numberIBAN = obj.numberIBAN;
    this.ownerName = obj.ownerName;
    this.tabNumberRouting = obj.tabNumberRouting;
    this.accountName = obj.accountName;
    this.intermediary = obj.intermediary;
    this.intermediaryCountry = obj.intermediaryCountry;
    this.intermediaryBankName = obj.intermediaryBankName;
    this.intermediaryAbaSwiftCode = obj.intermediaryAbaSwiftCode;
    this.forFurtherCredit = obj.forFurtherCredit;
    this.accountType = obj.accountType;
    this.accountClass = obj.accountClass;
    this.recipientRelationship = obj.recipientRelationship;
    this.providerBankAccountId = obj.providerBankAccountId;
    this.isActive = obj.isActive ?? true;
    this.bankType = obj.bankType || null;
    // Campos específicos para ACH Colombia
    this.beneficiaryFirstName = obj.beneficiaryFirstName;
    this.beneficiaryLastName = obj.beneficiaryLastName;
    this.documentId = obj.documentId;
    this.documentType = obj.documentType;
    this.email = obj.email;
    this.bankCode = obj.bankCode;
    // Campos de endereço (para RTP e outros tipos)
    this.addressLine1 = obj.addressLine1;
    this.addressLine2 = obj.addressLine2;
    this.city = obj.city;
    this.stateProvinceRegion = obj.stateProvinceRegion;
    this.country = obj.country;
    this.postalCode = obj.postalCode;
    // Campos específicos para SPEI
    this.protocol = obj.protocol;
    this.institutionCode = obj.institutionCode;
    // Campos específicos para Transfers 3.0
    this.transfersType = obj.transfersType;
    // Campos específicos para International Swift
    this.confirmAccountNumber = obj.confirmAccountNumber;
    this.bankAddress = obj.bankAddress;
    this.bankAddressLine1 = obj.bankAddressLine1;
    this.bankAddressLine2 = obj.bankAddressLine2;
    this.bankCity = obj.bankCity;
    this.bankStateProvinceRegion = obj.bankStateProvinceRegion;
    this.bankPostalCode = obj.bankPostalCode;
    this.bankCountry = obj.bankCountry;
    this.swiftPaymentCode = obj.swiftPaymentCode;
    this.swiftIfscBranchCode = obj.swiftIfscBranchCode;
    this.businessIndustry = obj.businessIndustry;
    this.ddiPhoneNumber = obj.ddiPhoneNumber;
    this.phoneNumber = obj.phoneNumber;
    this.taxId = obj.taxId;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}